import EventShareStandings from '@/screens/EventShareStandings';

export default function PrivateEventEventIdStandingsShareIndexRoute() {
  return <EventShareStandings />;
}
